import { render, staticRenderFns } from "./jobnum-list.vue?vue&type=template&id=85883390&scoped=true&"
import script from "./jobnum-list.vue?vue&type=script&lang=js&"
export * from "./jobnum-list.vue?vue&type=script&lang=js&"
import style0 from "./jobnum-list.vue?vue&type=style&index=0&id=85883390&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85883390",
  null
  
)

export default component.exports